// Planning chauffeurs : normalisation, fusion serveur/local et brouillon local des saisies non enregistrées.
const DRAFT_PREFIX = 'dlv_planning_draft_v1:';

export const cellKey = (userId, date) => `${userId}|${date}`;

export function normalizeServerRow(s) {
  const row = { ...s };
  const tour = (row.tour_type || '').toLowerCase().trim().replace(/[éèê]/g, 'e').replace(/’/g, "'");
  if (tour === "en cours d'integration") {
    Object.assign(row, { status: 'en_cours_integration', tour_type: null, loading_time: null, start_time: null,
      second_start_time: null, end_time: null, validation_status: null });
  }
  row._baseline_updated_at = s.updated_at || null;
  row._baseline_status = row.status || null;
  return row;
}

export function daysToSchedules(days) {
  const out = {};
  Object.entries(days || {}).forEach(([date, rows]) => {
    out[date] = {};
    (rows || []).forEach((s) => { out[date][s.user_id] = normalizeServerRow(s); });
  });
  return out;
}

export function touchedCells(schedules) {
  const cells = [];
  Object.entries(schedules || {}).forEach(([date, day]) => {
    Object.entries(day || {}).forEach(([userId, cell]) => {
      if (cell?._touched) cells.push({ date, userId, cell });
    });
  });
  return cells;
}

// Garde les saisies locales ; signale un conflit si le serveur a changé depuis leur base.
export function mergeServerIntoLocal(local, server) {
  const merged = { ...server };
  touchedCells(local).forEach(({ date, userId, cell }) => {
    const serverCell = server[date]?.[userId];
    const changed = serverCell && (serverCell.updated_at || null) !== (cell._baseline_updated_at || null);
    const next = changed && !cell._conflict_ack
      ? { ...cell, _conflict: true, _server: serverCell }
      : { ...cell };
    merged[date] = { ...(merged[date] || {}), [userId]: next };
  });
  return merged;
}

const draftKey = (userId) => `${DRAFT_PREFIX}${userId || 'anon'}`;

export function saveDraft(userId, schedules) {
  try {
    const cells = touchedCells(schedules).map(({ date, userId: uid, cell }) => {
      const { _server, ...rest } = cell;
      return { date, userId: uid, cell: rest };
    });
    if (cells.length === 0) localStorage.removeItem(draftKey(userId));
    else localStorage.setItem(draftKey(userId), JSON.stringify({ saved_at: new Date().toISOString(), cells }));
  } catch (e) {
    // stockage indisponible : la saisie reste en mémoire
  }
}

export function loadDraft(userId) {
  try {
    const raw = localStorage.getItem(draftKey(userId));
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function clearDraft(userId) {
  try { localStorage.removeItem(draftKey(userId)); } catch (e) { /* ignore */ }
}

const COMPARED = ['status', 'tour_type', 'start_time', 'second_start_time', 'loading_time', 'comment', 'admin_comment'];
export function sameAsServer(cell, server) {
  if (!server) return false;
  return COMPARED.every((k) => (cell?.[k] || null) === (server?.[k] || null));
}

export function applyDraft(schedules, draft) {
  const next = { ...schedules };
  (draft?.cells || []).forEach(({ date, userId, cell }) => {
    next[date] = { ...(next[date] || {}), [userId]: { ...cell, _touched: true, _from_draft: true } };
  });
  return next;
}

export function describeSaveError(error) {
  const status = error?.response?.status;
  if (status === 401) return 'Déconnecté (session expirée ou même compte ouvert sur un autre appareil) : vos saisies sont conservées sur cet appareil. Reconnectez-vous dans un nouvel onglet puis cliquez sur « Enregistrer ».';
  if (status === 403) return error.response?.data?.detail || 'Action non autorisée pour votre profil. Aucune donnée n\u2019a été enregistrée.';
  if (!error?.response) return 'Connexion interrompue ou trop lente : l\u2019enregistrement n\u2019est pas confirmé. Vos saisies sont conservées, réessayez.';
  const detail = error.response?.data?.detail;
  if (detail?.code === 'save_in_progress') return detail.message;
  return `Échec de l\u2019enregistrement (${status}) : ${typeof detail === 'string' ? detail : 'erreur serveur'}. Vos saisies sont conservées.`;
}
